var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from "react";
import styled from "styled-components";
import { Divider, Typography } from "@material-ui/core";
import { useTypedSelector } from "../../state/store";
var StyledDivider = styled(Divider)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 2px;\n"], ["\n  height: 2px;\n"])));

var LoginPrompt = function LoginPrompt(_a) {
  var content = _a.content,
      fullQuizInfoShown = _a.fullQuizInfoShown;
  var contents = content || React.createElement(DefaultLoginMessage, {
    fullQuizInfoShown: fullQuizInfoShown
  });
  return React.createElement(React.Fragment, null, contents);
};

var DefaultLoginMessage = function DefaultLoginMessage(_a) {
  var fullQuizInfoShown = _a.fullQuizInfoShown;
  var languageLabels = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var labelPropertyName = "loginTo" + (fullQuizInfoShown ? "Answer" : "View") + "PromptLabel";
  return React.createElement(React.Fragment, null, React.createElement(MessageContainer, {
    fullQuizInfoShown: !!fullQuizInfoShown
  }, React.createElement(StyledTypography, {
    variant: "subtitle1"
  }, languageLabels ? languageLabels.general[labelPropertyName] : "Log in to " + (fullQuizInfoShown ? "answer" : "view") + " the quiz")), fullQuizInfoShown && React.createElement(StyledDivider, {
    variant: "fullWidth"
  }));
};

var MessageContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 1rem;\n  ", "\n"], ["\n  padding: 1rem;\n  ", "\n"])), function (_a) {
  var fullQuizInfoShown = _a.fullQuizInfoShown;
  return fullQuizInfoShown ? "" : "height: 400px";
});
var StyledTypography = styled(Typography)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 1.5rem !important;\n  text-align: center;\n"], ["\n  font-size: 1.5rem !important;\n  text-align: center;\n"])));
export default LoginPrompt;
var templateObject_1, templateObject_2, templateObject_3;